import { Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PlatformLocation } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class ShareProcessListService {

  constructor(
    private clipboard: Clipboard,
    private snackbar: MatSnackBar,
    private location: PlatformLocation,
    private titleService: Title,
    private metaService: Meta,
  ) { }

  share(processList: any, company: any) {
    let path = environment.path; 
    // const link = this.location.hostname == 'localhost' ? `http://localhost:4200/shared-process/${processList.id}` : `https://colloca.com.br/${path}/shared-process/${processList.id}`;
    const link = this.location.hostname == 'localhost' ? `http://localhost:4200/shared-process/${processList.id}` : `https://colloca.com.br/${path}/share.php?id=${processList.id}&company=${company}`;
    this.clipboard.copy(link);
    this.snackbar.open('Link copiado com sucesso pronto para ser compartilhado', 'Ok', { duration: 3000 })
  }

  shareview(processList: any, company: any){
    let path = environment.path; 
    const link = this.location.hostname == 'localhost' ? `http://localhost:4200/shared-process/${processList.id}` : `https://colloca.com.br/${path}/share.php?id=${processList.id}&company=${company}`;
    return link;
  }
}
